module.exports = __webpack_public_path__ + "static/img/newOne.fc62fea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earnImg/newOne.png
// module id = 4oWK
// module chunks = 1